import ApiBase from '@/api/api-base'
import { ACTIVE_BASE_REST } from '@/api/constants'

export default class BaseInfoOrderPropertiesLoad extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/property/load`)
  }
}
